// extracted by mini-css-extract-plugin
module.exports = {"selected":"SelectButtons_ketogo_selected__2cR7u"};